import classNames from 'classnames';
import * as React from 'react';
import { useIntl } from 'react-intl';
import BooksMenuDescription from '../BooksMenuDescription';
import css from './BooksMenuDescWithButton.module.scss';
import { RSButton } from 'src/reservation-page/RSButton';

interface Props {
  className?: string;
  text: string;
  postable: boolean;
  onClick?: (event: React.MouseEvent) => void;
  value?: number;
}

const BooksMenuDescWithButton = ({
  className,
  text,
  postable,
  onClick,
  value,
}: Props) => {
  const classes = classNames(css.BooksMenuDescWithButton, className);
  const intl = useIntl();

  return (
    <div className={classes}>
      <BooksMenuDescription
        className={css.BooksMenuDescWithButton__Description}
        text={text}
      />

      <div className="flex justify-end">
        <div>
          <RSButton
            variant="outline"
            isLoading={!postable}
            disabled={!postable}
            value={value}
            onClick={onClick}
          >
            {intl.formatMessage({ id: 'books.button.select' })}
          </RSButton>
        </div>
      </div>
    </div>
  );
};

export default BooksMenuDescWithButton;
